import { Box, Flex, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import {
  detailsCard,
  get_Error_Rejected_count,
  openPositionCount,
} from "apis/dashboard";
import { GoStop } from "react-icons/go";
import { useEffect, useState, lazy, Suspense } from "react";
import { AiOutlineStop } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import urls from "utils/routes";
import theme from "./utils/theme";
import {
  MdCheckCircle,
  MdCancel,
  MdOutlineError,
  MdPending,
} from "react-icons/md";
import { TbReport } from "react-icons/tb";
import ClientstatusIcon from "assets/icons/ClientstatusIcon";
import OrderStatusIcon from "assets/icons/OrderStatusIcon";
import BrokerRecordStatusIcon from "assets/icons/BrokerRecordStatusIcon";
const ActiveUserIcon = lazy(() => import("assets/icons/ActiveUserIcon"));
const DeletedUserIcon = lazy(() => import("assets/icons/DeletedUserIcon"));
const PLIcon = lazy(() => import("assets/icons/PLIcon"));
const PausedUserIcon = lazy(() => import("assets/icons/PausedUserIcon"));
const TradeHistoryIcon = lazy(() => import("assets/icons/TradeHistoryIcon"));
const TradegraphIcon = lazy(() => import("assets/icons/TradegraphIcon"));

const Cardsdashboad = () => {
  const brand = theme.colors.brand[400];
  const location = useLocation();
  const navigate = useNavigate();
  const [activeuser, setAtive] = useState(0);
  const [pauseuser, setPause] = useState(0);
  const [Discarduser, setDiscard] = useState(0);
  const [pending, setPending] = useState(0);
  const [positions, setPositions] = useState(0);
  const [cancel, setCancel] = useState(0);
  const [partial, setPartial] = useState(0);
  const [error, setError] = useState(0);

  const pathname = window.location.pathname;
  useEffect(() => {
    dashboarddata();
  }, [location]);

  const dashboarddata = async () => {
    try {
      const [detailsCardResponse, ErrorRejResponse, openPositionCountResponse] =
        await Promise.all([detailsCard()]);

      const {
        open_positions,
        pending_orders,
        error_orders,
        active_clients,
        paused_clients,
        cancel_orders,
        partial_orders,
        ...rest
      } = detailsCardResponse.data[0];
      localStorage.setItem("active_user_size", active_clients);
      setAtive(active_clients+paused_clients);
setCancel(cancel_orders);
setPartial(partial_orders);
      setPause(paused_clients);
      // setDiscard(discard_client);
      setPending(pending_orders);
      setPositions(open_positions);
      setError(error_orders);
    } catch (error) {
      console.error(error);
    }
  };

  if (
    location.pathname == "/Market-Place" ||
    location.pathname == "/strategy-details"
  ) {
    return null;
  }

  return (
    <Box ml="20px" mt="2" w="98%" zIndex={"18"} >
      <Grid templateColumns="53% 10% 35%" gap="2%" w="100%" >
        <GridItem h="100%" >
          <Flex
            w="100%"
            h="100%"
            alignItems={"center"}
            position="relative"
            flexDirection={"column"}
            ml="0"
          >
            <Flex
              width={{ base: "80%", md: "50%", lg: "33%" }}
              height="23px"
              flexShrink="0"
              borderRadius="0.3125rem"
              background="brand.900"
              position="relative"
              display="flex"
              alignItems="center"
              zIndex={"10"}
              justifyContent={"center"}
            >
              <Text
                color="brand.500"
                display="flex"
                alignItems="center"
                gap="1"
                justifyContent={"center"}
                fontSize="0.75rem"
                borderColor="transparent"
                fontWeight="700"
                lineHeight="normal"
                textAlign={"center"}
                w="100%"
              >
                <OrderStatusIcon />
                Order Status
              </Text>
            </Flex>
            <Box
              w="65%"
              h="58px"
              flexShrink="0"
              borderRadius="0.625rem 0.625rem 0rem 0.625rem"
              bg="brand.200"
              position="absolute"
              zIndex={4}
              top="3"
            ></Box>
            {/* <Flex
              w="100%"
              h="60%"
              position="absolute"
              top="10"
              // justifyContent={"space-between"}gap

              border="1px solid red"
              gap="5"
            >
              <Box
                // width={{ base: '60px', md: '80px', lg: '100px' }}
                w="24%"
                h="100%"
                flexShrink={0}
                borderRadius="0.625rem"
                bg="brand.700"
                cursor={"pointer"}
                zIndex="5"
                boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
                // border="1px solid gray"
                onClick={() => {
                  navigate(urls.openRequest);
                  setTimeout(() => {
                    // window.location.reload();
                  }, 0);
                  // window.location.reload();
                }}
              >
                <Flex
                  marginTop={"2"}
                  alignItems={"center"}
                  flexDirection={"column"}
                >
                  <TradegraphIcon width="30px" height="30px" />
                </Flex>
                <Box w="50%" m="auto">
                  <Text
                    mt="1"
                    borderRadius={4}
                    // width="0.8125rem"
                    height="1.4rem"
                    flex-shrink="0"
                    bordeRadius="0.0625rem"
                    background="brand.600"
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    color="brand.700"
                    fontSize="1.0125rem"
                    borderColor="transparent"
                    fontWeight="700"
                    lineHeight="normal"
                    marginBottom={"1"}
                  >
                    {positions}
                  </Text>
                </Box>
                <Text
                  textAlign="center"
                  color="brand.600"
                  borderColor="transparent"
                  fontWeight="700"
                  fontSize="11px"
                  fontStyle="normal"
                >
                  Open{" "}
                </Text>
              </Box>
              <Box
                // width={{ base: '60px', md: '80px', lg: '100px' }}
                w="24%"
                h="100%"
                flexShrink={0}
                borderRadius="0.625rem"
                bg="brand.700"
                cursor={"pointer"}
                zIndex="5"
                boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
                // border="1px solid gray"
                onClick={() => navigate("/Pendingorders")}
              >
                <Flex
                  marginTop={"2"}
                  alignItems={"center"}
                  justifyContent={"center"}

                  // mt="6"
                >
                  <Icon color="brand.600" f w="25px" h="25px" as={MdPending} />
                </Flex>

                <Box w="50%" m="auto">
                  <Text
                    mt="2"
                    borderRadius={4}
                    // width="0.8125rem"
                    height="1.4rem"
                    flex-shrink="0"
                    bordeRadius="0.0625rem"
                    background="brand.600"
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    color="brand.700"
                    borderColor="transparent"
                    fontWeight="700"
                    fontSize="1.0125rem"
                    fontStyle="normal"
                    lineHeight="normal"
                    // fontFamily: DM Sans;
                    marginBottom={"1"}
                  >
                    {pending}
                  </Text>
                </Box>
                <Text
                  textAlign="center"
                  color="brand.600"
                  borderColor="transparent"
                  fontWeight="700"
                  fontSize="11px"
                  fontStyle="normal"
                >
                  Pending{" "}
                </Text>
              </Box>
              <Box
                // width={{ base: '60px', md: '80px', lg: '100px' }}
                w="24%"
                h="100%"
                flexShrink={0}
                borderRadius="0.625rem"
                bg="brand.700"
                cursor={"pointer"}
                zIndex="5"
                boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
                // border="1px solid gray"
                onClick={() => navigate("/Errororders")}
              >
                <Flex
                  marginTop={"2"}
                  alignItems={"center"}
                  flexDirection={"column"}
                >
                  <Icon color="brand.600" f w="25px" h="25px" as={MdCancel} />
                </Flex>

                <Box w="50%" m="auto">
                  <Text
                    mt="3"
                    borderRadius={4}
                    // width="0.8125rem"
                    height="1.4rem"
                    flex-shrink="0"
                    bordeRadius="0.0625rem"
                    background="brand.600"
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    color="brand.700"
                    borderColor="transparent"
                    fontWeight="700"
                    fontSize="1.0125rem"
                    marginBottom={"1"}
                    // fontFamily: DM Sans;
                  >
                    {error}
                  </Text>
                </Box>
                <Text
                  textAlign="center"
                  color="brand.600"
                  borderColor="transparent"
                  fontWeight="700"
                  fontSize="11px"
                  fontStyle="normal"
                >
                  Error{" "}
                </Text>
              </Box>
              <Box
                // width={{ base: '60px', md: '80px', lg: '100px' }}
                w="24%"
                h="100%"
                flexShrink={0}
                borderRadius="0.625rem"
                bg="brand.700"
                cursor={"pointer"}
                zIndex="5"
                boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
                // border="1px solid gray"
                onClick={() => {
                  navigate(urls.openRequest);
                  setTimeout(() => {
                    // window.location.reload();
                  }, 0);
                  // window.location.reload();
                }}
              >
                <Flex
                  marginTop={"2"}
                  alignItems={"center"}
                  flexDirection={"column"}
                >
                  <TradegraphIcon width="30px" height="30px" />
                </Flex>
                <Box w="50%" m="auto">
                  <Text
                    mt="1"
                    borderRadius={4}
                    // width="0.8125rem"
                    height="1.4rem"
                    flex-shrink="0"
                    bordeRadius="0.0625rem"
                    background="brand.600"
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    color="brand.700"
                    fontSize="1.0125rem"
                    borderColor="transparent"
                    fontWeight="700"
                    lineHeight="normal"
                    marginBottom={"1"}
                  >
                    {positions}
                  </Text>
                </Box>
                <Text
                  textAlign="center"
                  color="brand.600"
                  borderColor="transparent"
                  fontWeight="700"
                  fontSize="11px"
                  fontStyle="normal"
                >
                  Open{" "}
                </Text>
              </Box>
            </Flex> */}
            <Grid
  w="100%"
  h="60%"
  position="absolute"
  top="10"
  
  gap="5"
  templateColumns="repeat(5, 1fr)"
>
  <GridItem
    w="100%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {
      navigate(urls.openRequest);
      setTimeout(() => {}, 0);
    }}
  >
    <Flex marginTop="2" alignItems="center" flexDirection="column">
      <TradegraphIcon width="30px" height="30px" />
    </Flex>
    <Box w="50%" m="auto">
      <Text
        mt="1"
        borderRadius={4}
        height="1.4rem"
        background="brand.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="brand.700"
        fontSize="1.0125rem"
        fontWeight="700"
        marginBottom="1"
      >
        {positions}
      </Text>
    </Box>
    <Text textAlign="center" color="brand.600" fontWeight="700" fontSize="11px">Open Position</Text>
  </GridItem>

  <GridItem
    w="100%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => navigate("/Pendingorders")}
  >
    <Flex marginTop="2" alignItems="center" justifyContent="center">
      <Icon color="brand.600" w="25px" h="25px" as={MdPending} />
    </Flex>
    <Box w="50%" m="auto">
      <Text
        mt="2"
        borderRadius={4}
        height="1.4rem"
        background="brand.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="brand.700"
        fontSize="1.0125rem"
        fontWeight="700"
        marginBottom="1"
      >
        {pending}
      </Text>
    </Box>
    <Text textAlign="center" color="brand.600" fontWeight="700" fontSize="11px">Pending</Text>
  </GridItem>

  <GridItem
    w="100%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => navigate("/Errororders")}
  >
    <Flex marginTop="2" alignItems="center" flexDirection="column">
      <Icon color="brand.600" w="25px" h="25px" as={MdCancel} />
    </Flex>
    <Box w="50%" m="auto">
      <Text
        mt="3"
        borderRadius={4}
        height="1.4rem"
        background="brand.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="brand.700"
        fontSize="1.0125rem"
        fontWeight="700"
        marginBottom="1"
      >
        {error}
      </Text>
    </Box>
    <Text textAlign="center" color="brand.600" fontWeight="700" fontSize="11px">Error</Text>
  </GridItem>

  <GridItem
    w="100%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {
      navigate(urls.cancelorder);
      setTimeout(() => {}, 0);
    }}
  >
    <Flex marginTop="2" alignItems="center" flexDirection="column">
      {/* <TradegraphIcon width="30px" height="30px" /> */}
    
      <Icon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
  <path
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M3 6h18M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M10 11v6M14 11v6"
  />
</Icon>



    </Flex>
    <Box w="50%" m="auto">
      <Text
        mt="1"
        borderRadius={4}
        height="1.4rem"
        background="brand.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="brand.700"
        fontSize="1.0125rem"
        fontWeight="700"
        marginBottom="1"
      >
        {cancel}
      </Text>
    </Box>
    <Text textAlign="center" color="brand.600" fontWeight="700" fontSize="11px">Cancel</Text>
  </GridItem>
  <GridItem
    w="100%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {
      navigate(urls.partialorder);
      setTimeout(() => {}, 0);
    }}
  >
    <Flex marginTop="2" alignItems="center" flexDirection="column">
    <Icon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
  <path
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM12 4v8h8"
  />
</Icon>
    </Flex>
    <Box w="50%" m="auto">
      <Text
        mt="1"
        borderRadius={4}
        height="1.4rem"
        background="brand.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="brand.700"
        fontSize="1.0125rem"
        fontWeight="700"
        marginBottom="1"
      >
        {partial}
      </Text>
    </Box>
    <Text textAlign="center" color="brand.600" fontWeight="700" fontSize="11px">Partial</Text>
  </GridItem>
</Grid>
          </Flex>
        </GridItem>
        <GridItem h="100%">
          <Flex
            w="100%"
            h="150px"
            alignItems={"center"}
            position="relative"
            flexDirection={"column"}
          >
           <Flex
  width={{ base: "80%", md: "50%", lg: "100%" }}
  height="23px"
  flexShrink="0"
  borderRadius="0.3125rem"
  background="brand.900"
  position="relative"
  alignItems="center"
  zIndex="10"
  justifyContent="center"  // Ensures the content is centered horizontally
>
  <Text
    color="brand.500"
    zIndex="10"
    fontSize="0.75rem"
    fontStyle="normal"
    borderColor="transparent"
    fontWeight="700"
    lineHeight="normal"
    display="flex"
    alignItems="center"  // Ensures vertical alignment of icon and text
    gap="1"  // Spacing between the icon and text
    justifyContent="center"  // Ensures the content is centered horizontally
    width="100%"  // Expands the width to take up available space
    whiteSpace="nowrap"  // Prevents text from wrapping
  >
    <ClientstatusIcon /> {/* Your Icon */}
    Clients Status
  </Text>
</Flex>

            <Box
              w="65%"
              h="58px"
              flexShrink="0"
              borderRadius="0.625rem 0.625rem 0rem 0.625rem"
              bg="brand.200"
              position="absolute"
              zIndex={4}
              top="3"
            ></Box>
           <Grid
  w="100%"
  h="60%"
  position="absolute"
  top="10"
  gap="5"
  templateColumns="repeat(1, 1fr)"
>
  <GridItem
    w="95%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => navigate("/clients", { state: { api_status: "active" } })}
  >
    <Flex marginTop="2" alignItems="center" flexDirection="column">
      <ActiveUserIcon width="30px" height="30px" />
    </Flex>
    <Box w="50%" m="auto">
      <Text
        mt="1"
        borderRadius={4}
        height="1.4rem"
        background="brand.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="brand.700"
        fontSize="1.0125rem"
        fontWeight="700"
        marginBottom="1"
      >
        {activeuser}
      </Text>
    </Box>
    <Text textAlign="center" color="brand.600" fontWeight="700" fontSize="11px">Active/Paused</Text>
  </GridItem>

  {/* <GridItem
    w="100%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {}}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Box display="flex" justifyContent="center">
      <GoStop fontSize="55px" />
    </Box>
  </GridItem> */}
</Grid>

          </Flex>
        </GridItem>
        <GridItem h="100%" >
          <Flex
            w="90%"
            h="150px"
            alignItems={"center"}
            position="relative"
            flexDirection={"column"}
          >
            <Box
              width={{ base: "80%", md: "50%", lg: "33%" }}
              height="23px"
              flexShrink="0"
              borderRadius="0.3125rem"
              background="brand.900"
              position="relative"
              display="flex"
              alignItems="center"
              justifyContent={"center"}
              // zIndex={"10"}
            >
              <Text
                color="brand.500"
                borderColor="transparent"
                fontWeight="700"
                fontSize="0.75rem"
                fontStyle="normal"
                display="flex"
                alignItems="center"
                gap="1"
                justifyContent={"center"}
                lineHeight="normal"
              >
                <BrokerRecordStatusIcon />
                Records
              </Text>
            </Box>
            <Box
              w="65%"
              h="58px"
              flexShrink="0"
              borderRadius="0.625rem 0.625rem 0rem 0.625rem"
              bg="brand.200"
              position="absolute"
              zIndex={4}
              top="3"
            ></Box>
           <Grid
  w="100%"
  h="60%"
  position="absolute"
  top="10"
  templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
  gap={4}
  justifyItems="center"
  alignItems="center"
>
  <GridItem
    w="95%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {
      navigate(urls.tradehistory);
      setTimeout(() => {}, 0);
    }}
  >
    <Box display="flex" mt="1" justifyContent="center">
      <TradeHistoryIcon width="42px" height="42px" />
    </Box>
    <Text
      m="auto"
      width={{ base: '100%', md: '80%', lg: '50%' }}
      color="brand.600"
      textAlign="center"
      fontWeight="700"
      fontSize="11px"
      fontStyle="normal"
    >
      Trade History
    </Text>
  </GridItem>

  <GridItem
    w="95%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {
      navigate('/P&L');
    }}
  >
    <Box display="flex" mt="1" justifyContent="center">
      <PLIcon width="42px" height="42px" />
    </Box>
    <Text
      m="auto"
      width={{ base: '100%', md: '80%', lg: '60%' }}
      color="brand.600"
      textAlign="center"
      fontSize="11px"
      fontStyle="normal"
      fontWeight="700"
    >
      P&L Statement
    </Text>
  </GridItem>

  <GridItem
    w="95%"
    h="100%"
    borderRadius="0.625rem"
    bg="brand.700"
    cursor="pointer"
    zIndex="5"
    boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    onClick={() => {
      navigate('/Reports');
    }}
  >
    <Box display="flex" justifyContent="center">
      <TbReport fontSize="60px" />
    </Box>
    <Text
      m="auto"
      width={{ base: '100%', md: '80%', lg: '60%' }}
      color="brand.600"
      textAlign="center"
      fontSize="11px"
      fontWeight="700"
    >
      Reports
    </Text>
  </GridItem>
</Grid>

          </Flex>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Cardsdashboad;
